<template>
  <div class="copy-dtx-table-wrapper">
    <div class="copy-dtx-table">
    <table :class="{ admin: isTenantAdmin }">
        <thead v-if="showHeader">
      <tr>
        <th>Name</th>
        <th>Contact No</th>
        <th>Email</th>
        <th>GST</th>
        <th>Industry Vertical</th>
        <th v-if="beaconAdmin">Type</th>
        <th v-if="!beaconAdmin">Status</th>
        <th v-show="(isTenantAdmin || beaconAdmin) && !isOnProjectLevel">Action</th>
      </tr>
    </thead>
      <tbody v-if="!loading && displayData.length">
        <tr
          v-for="(row, index) in displayData"
            :key="row.id"
            :class="{'deactivatedRow': row.status === 2 || row.associationStatus === 2}"
          >
            <td class="company-name-cell">
              <div class="cell-content">
                <a v-if="row.company_logo_blob_key" :href="row.company_url" target="_blank" class="logo-link">
                  <img :src="row.company_logo_blob_key" alt="logo"/>
                </a>
                <span class="name-text">{{ row.company_name || '--' }}</span>
              </div>
            </td>

        <td>{{ row.company_phone || '--' }}</td>
        <td>{{ row.company_email || '--' }}</td>
        <td>{{ row.GSTIN || '--' }}</td>
        <td>{{ row.industry_vertical_value.name || '--' }}</td>
        <td v-if="beaconAdmin">{{ row.tenant_type_details.type || '--' }}</td>

        <td v-if="!beaconAdmin">
              <div :class="`vendor-status vendor-status-${row.vendorStatus}`">
                {{ row.vendorStatus | statusNames }}
              </div>
            </td>
        <td v-show="(isTenantAdmin || beaconAdmin) && !isOnProjectLevel" class="action-column">
        <div class="action-icons">
          <a v-show="row.company_url" :href="row.company_url" target="_blank">
          <img class="edit pointer" v-tooltip="'Company URL'" src="~@/assets/images/url.svg" alt="URL"/>
              </a>
          <span v-show="row.status === 1 && beaconAdmin" v-tooltip="'Deactivate tenant'" class="btn pointer" @click="updateTenantStatus(index, 2)">
            <img src="~@/assets/images/delete-icon.svg" alt="Delete" />
          </span>
                <img v-show="row.associationStatus === 1 && row.status === 1 && !beaconAdmin"
                     v-tooltip="'To De-activate tenant'"
                     class="edit pointer"
                     src="~@/assets/images/deactive.svg"
                     alt="Deactivate"
                     @click="deactivateCollaboratingTenant(row, index)"/>

            <img v-show="row.associationStatus === 2 && !beaconAdmin"
                     v-tooltip="'To activate tenant'"
                     class="edit pointer"
                     src="~@/assets/images/active.svg"
                     alt="Activate"
                     @click="activateCollaboratingTenant(row, index)"/>

                <img v-show="row.status === 4"
                     v-tooltip="'Re-Invite tenant'"
                     class="edit pointer"
                     src="~@/assets/images/icons/invite.svg"
                     alt="Invite"
                     @click="tenantReInvite(row.id)"/>

                <img v-show="row.status !== 1 && beaconAdmin"
                     v-tooltip="'Activate tenant'"
                     src="~@/assets/images/icons/undo-icon.svg"
                     class="edit pointer"
                     alt="Undo"
                     @click="updateTenantStatus(index, 1)"/>

                <img v-show="row.associationStatus !== 2"
                     v-tooltip="'Edit'"
                     src="~@/assets/images/pencil.svg"
                     alt="Edit"
                     class="edit pointer"
                     @click="EditCompany(row.id)"/>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="!loading && displayData.length === 0">
          <tr><td :colspan="8" class="no-data-cell">No Data Found</td></tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8">
              <div class="center-loader"><loading-circle /></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import LoadingCircle from './loadingCircle.vue'
import { alert, success } from '@/plugins/notification'
import ConfirmationDialog from '@/plugins/confirmationDialog'
import { GetAllTenantsListData, ReInviteTenant, UpdateTenantStatusBeaconAdmin, updateCollaboratingTenantStatus } from '@/api'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: { LoadingCircle },
  name: 'company-table',
  props: {
    companyList: { type: Array, default: () => [] },
    pageNumber: { type: [Number, String], default: 1 },
    perPage: { type: [Number, String], default: 10 },
    showHeader: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    beaconAdmin: { type: Boolean, default: false },
    selectedTab: { type: String }
  },
  filters: {
    statusNames (value) {
      const names = { COMPLETED: 'ACTIVE', ONGOING: 'ONGOING', CANCELLED: 'CANCELLED', REJECTED: 'REJECTED' }
      return names[value] || 'N/A'
    }
  },
  methods: {
    EditCompany (rowId) { this.$router.push(`/edit-user/${rowId}`) },
    ...mapMutations(['setTenentList', 'setChildTenantList']),
    async updateTenantStatus (index, status) {
      const action = status === 1 ? 'activate' : 'deactivate'
      ConfirmationDialog(`Are you sure you want to ${action} the tenant ${this.companyList[index].company_name}`, async (res) => {
        if (res) {
          try {
            await UpdateTenantStatusBeaconAdmin(this.companyList[index].id, status)
            this.$notify.success('Successfully updated the tenant status')
            const tenantList = JSON.parse(JSON.stringify(this.companyList))
            tenantList[index].status = status
            this.setTenentList(tenantList)
          } catch (err) { this.$notify.alert(err?.message ?? 'Something went wrong') }
        }
      })
    },
    deactivateCollaboratingTenant (tenant) {
      ConfirmationDialog(`Are you sure you want to deactivate the tenant ${tenant.company_name}`, (res) => {
        if (res) { updateCollaboratingTenantStatus(tenant.id, 2).then(() => this.getAllTenantList()).catch(() => alert('Unable to deactivate tenant')) }
      })
    },
    activateCollaboratingTenant (tenant) {
      ConfirmationDialog(`Are you sure you want to activate the tenant ${tenant.company_name}`, (res) => {
        if (res) { updateCollaboratingTenantStatus(tenant.id, 1).then(() => this.getAllTenantList()).catch(() => alert('Unable to activate tenant')) }
      })
    },
    tenantReInvite (tenantId) {
      if (this.disableReIniviteButton) return
      this.disableReIniviteButton = true
      ReInviteTenant({ tenant_id: tenantId }).then(data => {
        if (data.message === 'Invitation Resent') { success('Tenant Re-invited successfully') } else { alert('Error re-inviting tenant') }
      }).catch(() => alert('Error re-inviting tenant')).finally(() => { this.disableReIniviteButton = false })
    },
    getAllTenantList () {
      GetAllTenantsListData(this.user.userId, this.user.tenantId).then((res) => { this.$store.commit('setChildTenantList', res?.child_tenants) })
    }
  },
  computed: {
    ...mapGetters(['isTenantAdmin', 'isOnProjectLevel', 'user']),
    displayData () {
      return this.companyList.slice((this.pageNumber - 1) * this.perPage, this.pageNumber * this.perPage)
    }
  }
}
</script>

<style lang="scss" scoped>
.copy-dtx-table {
  table {
    td {
      vertical-align: middle;
      &.no-data-cell { text-align: center; padding: 2rem; color: #6c757d; font-size: var(--text-base); }
    }

    td.action-column {
      /* Locked width to prevent header/body mismatch */
      width: 170px !important;
      min-width: 170px !important;
      text-align: center;
    }
  }
}

.company-name-cell .cell-content {
  display: flex;
  align-items: center;
  gap: 10px;
  .logo-link img { width: 20px; height: 20px; object-fit: contain; }
  .name-text { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: var(--text-xs2); }
}

/* THE ALIGNMENT SYSTEM */
.action-icons {
  display: flex;
  /* flex-end anchors icons to the right, creating a clean vertical line */
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  height: 100%;
  padding-right: 15px;

  /* This ensures every icon wrapper takes exactly the same space */
  img, a, span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  img {
    object-fit: contain;
  }
}

.vendor-status {
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-block;
  min-width: 90px;
  text-align: center;
  font-size: var(--text-xs);
  &-COMPLETED { background: rgba(0, 128, 0, 0.1); color: green; }
  &-ONGOING { background: rgba(255, 165, 0, 0.1); color: orange; }
  &-REJECTED { background: rgba(198, 39, 52, 0.1); color: red; }
}

.center-loader { display: flex; justify-content: center; padding: 20px; }
</style>
